import CityPageTemplate from "../city-template/CityPageTemplate";
import { sierraVistaConfig } from "./data";

export default function SierraVistaPage() {
  return <CityPageTemplate config={sierraVistaConfig} />;
}